export default "5950db4836ff6b71ffca8cc8540d6482.svg";